import { UIIcon } from '../config/icons';
import { ABFilterBar } from '../lib/ab/filter-bar';
import { CBookingListView, cBookingsBySession } from '../lib/mdl/c-booking-admin';
import { CEventAdminView, CSession } from '../lib/mdl/c-event-admin';
import { TTicket } from '../lib/mdl/t-ticket';
import { the_alt_token } from '../lib/me/login';
import { UIDataAdapter } from '../lib/ui/component/adapter';
import { UIButton } from '../lib/ui/component/button';
import { UIList } from '../lib/ui/component/list';
import { $el } from '../lib/ui/elements';
import { UIScreen } from '../lib/ui/screen';
import { UIView, UIViewSpec } from '../lib/ui/view';
import { $analytics } from '../lib/y/analytics';
import { $i18n, yInterpolate } from '../lib/y/i18n';

class BookingCard extends UIView {
    constructor(booking: CBookingListView, all_tickets: TTicket[]) {
        super('div', 'tl-producer-card m-user');

        const tickets = booking.is_tickets_sent ? all_tickets.filter(t => t.booking_id == booking.id) : [];

        // this._adapter = new UIDataAdapter(ticket => {
        //     const url = '/docs/tickets/'+ticket.id+'?token='+$tl.the_login!.alt_token
        //     const print = $el.ICON(UIIcon.PRINT);
        //     print.addEventListener('click', () => {
        //         $analytics.track('Ticket Download', { event_name: event.name, session_time: session.time })
        //         const w = window.open(url);
        //         w && w.print();
        //     })

        //     return $el.DIV('tl-box-item', [
        //         $el.A(`/docs/tickets/${ticket.id}?token=${$tl.the_login!.alt_token}`, ticket.seat.unknown ? [
        //             $el.DIV('tl-box-item-row', 'Unknown seat'),
        //             $el.DIV('tl-box-item-row', ticket.name),
        //         ] : [
        //             $el.DIV('tl-box-item-row t-w-bold', ticket.seat.section),
        //             $el.DIV('tl-box-item-row', ['Row: ', $el.SPAN('t-w-bold', '' + ticket.seat.row), ' Seat: ', $el.SPAN('t-w-bold', '' + ticket.seat.seat)])
        //         ],'r-rows'),
        //         print
        //     ]);
        // });


        // def.addCustom({ title: $i18n.aa.c_tickets, width: -230, decorator: (td, row) => {
        //     td.classList.add('m-no-padding');
        //     td.ui_add(new TicketsBox(row, event, session, all_tickets));
        // } });

        // const sessions = event.active_sessions;
        // const booked = sessions.reduce((v,s) => v+s.amount_booked, 0);
        // const reserved = sessions.reduce((v,s) => v+s.amount_reserved, 0);
        // const standby = sessions.filter(s => s.time_y.is_future).reduce((v,s) => v+s.amount_standby, 0);
        // const total = sessions.reduce((v,s) => v+s.amount, 0);

        // const duplicate = new UIButton({ title: $i18n.aa.b_duplicate, icon: UIIcon.COPY });
        // duplicate.on_click = () => {
        //     $analytics.track('Event creation started', { duplicated: true })
        //     $location.push({ transient: new EventScreen({ duplicate: event }) });
        // }

        // const edit = new UIButton({ title: $i18n.aa.b_edit, icon: UIIcon.PEN_TO_SQUARE });
        // edit.on_click = () => {
        //     $location.push({ transient: new EventScreen({ event: event }) });
        // }
        // const manage = new UIButton({ title: $i18n.aa.b_add_tickets, icon: UIIcon.PLUS });
        // manage.on_click = () => {
        //     $location.push({ transient: new EventScreen({ event: event, manage: true })});
        // }

        // const image = $el.DIV('r-image');
        // uiSetBG(image, { media: model.pictures?.[0], variant: 'size-500' });

        // const session_chips = $el.DIV('r-chips m-gap');
        // const sessions = event.active_sessions;

        // for(let i = 0; i < sessions.length; i++) {
        //     if(i == 3) {
        //         session_chips.ui_add($el.DIV('tl-producer-chip', yInterpolate($i18n.pr.events_more, sessions.length - 3)));
        //         break;
        //     }
        //     const session = sessions[i];
        //     session_chips.ui_add($el.DIV('tl-producer-chip', [$el.SPAN('t-w-bold t-uppercase', session.time_y.format('d MMM')), ' ', $el.I(session.time_y.format('HH:mm'))]));
        // }

        // const status_chip = $el.DIV('tl-producer-chip');
        // const main_button: UIButton | undefined;

        // if(model.published) {
        //     status_chip.classList.add('m-green');
        //     status_chip.ui_add($i18n.pr.events_status_live);
        //     main_button = new UIButton({ title: '+ ' + $i18n.pr.events_add_tickets, classes: 'm-round m-compact ui-tint-subtle', on_click: () => {
        //         $location.push({ transient: new EventScreen({ event: event, manage: true })});
        //     }});
        // } else if(event.model.sessions.length) {
        //     status_chip.classList.add('m-yellow');
        //     status_chip.ui_add($i18n.pr.events_status_sent);
        //     main_button = new UIButton({ title: '+ ' + $i18n.pr.events_add_sessions, classes: 'm-round m-compact ui-tint-subtle', on_click: () => {
        //         $location.push({ transient: new EventScreen({ event: event, manage: true })});
        //     }});
        // } else {
        //     status_chip.classList.add('m-hollow');
        //     status_chip.ui_add($i18n.pr.events_status_draft);
        //     main_button = new UIButton({ title: '+ ' + $i18n.pr.events_add_sessions, classes: 'm-round m-compact ui-tint-subtle', on_click: () => {
        //         $location.push({ transient: new EventScreen({ event: event, manage: true })});
        //     }});
        // }

        // const booked_span = $el.I(reserved + ' / ' + total)

        // if(booked != reserved) {
        //     addTooltip(yInterpolate($i18n.aa.tt_session_booked, booked, reserved - booked), booked_span, { position: UIRelPos.Above, offset: 5 });
        //     booked_span.classList.add('tl-tooltip-underline');
        // }

        // const booking_text: UIViewAddSpec = [booked_span, ' ' + $i18n.aa.c_booked];

        // if(standby) {
        //     booking_text.push(' | ' + standby + ' ' + $i18n.aa.c_standby);
        //     const info = $el.ICON(UIIcon.CIRCLE_INFO | UIIcon.WEIGHT_SOLID);
        //     addTooltip([$i18n.aa.tt_add_amount, 
        //                     $el.A('https://support.partners.abundolive.se/hantera-evenemang/hur-fungerar-standby', $i18n.tl.b_read_more, 'u-link')], this, 
        //                     { offset: 8, click: info, anchor: info, position: UIRelPos.Above, classes: 'm-clickable' });
        //     booking_text.push(info);
        // }

        // const chips = $el.DIV('r-chips');


        this.ui_add([
            $el.DIV('r-info', [
                $el.B(booking.user_first_name + ' ' + booking.user_last_name),
                tickets.map((t, i) => {
                    let text = yInterpolate($i18n.pr.event_bookings_ticket, i + 1) + ': ';
                    if(t.seat) {
                        text += `${t.seat.section} - Row: ${t.seat.row} Seat: ${t.seat.seat}`;
                    } else {
                        text += $i18n.pr.event_bookings_unknown_seat + ' - ' + t.name;
                    }
                    return $el.B(text);
                }),
                $el.B('#' + booking.number),
            ]),
            $el.S(),
            !!tickets.length && new UIButton({ kind: 'k-square', icon: UIIcon.PRINT, classes: 'm-round m-bigger ui-tint-subtle', link: '/docs/tickets/' + booking.id + '/' + booking.token + '?inline=true' }),
            // $el.DIV('s-tiny'),
            // new UIButton({kind: 'k-text', icon: UIIcon.ELLIPSIS_STROKE, classes: 'ui-tint-fg', on_click: () => {
            // }}),
        ]);
    }
}

export class ProducerEventBookingsScreen extends UIScreen {
    private _filter_bar!: ABFilterBar;
    private _all_bookings?: CBookingListView[];
    private _all_tickets?: TTicket[];
    private _grid!: UIDataAdapter<CBookingListView, BookingCard>;

    constructor(private _event: CEventAdminView, private _session: CSession) {
        super({ no_crumbs: true });
        this.title = $i18n.aa.n_bookings;
    }

    protected override async fillContent(content: UIViewSpec) {
        const doSearch = () => this._doSearch();

        const event = this._event;
        const session = this._session;
        const bookings_response = await cBookingsBySession(session.id);
        this._all_bookings = bookings_response.bookings;
        this._all_tickets = bookings_response.tickets;

        const filter_bar = this._filter_bar = new ABFilterBar({ on_search: doSearch, on_sort: doSearch, sort_options: [{ key: 'name', name: $i18n.pr.filter_name }, { key: 'number', name: $i18n.aa.c_booking_number }] });

        // const top_line = $el.DIV('r-top-line', event.name + ' - ' + session.time_y.format('yyyy-MM-dd HH:mm'));

        // content.ui_prepend(top_line);

        const download_pdf = new UIButton({
            title: $i18n.aa.b_download_pdf, classes: 'ui-tint-subtle m-compacter', left_icon: UIIcon.DOWNLOAD, link: `/docs/session/${session.id}/bookings?format=pdf&token=${the_alt_token}`, on_click: () => {
                $analytics.track('Booking List Download', { event_name: event.name, session_time: session.time });
            }
        });

        const grid = this._grid = new UIDataAdapter(b => new BookingCard(b, this._all_tickets || []));

        content.ui_add($el.DIV('ui-section', $el.DIV('tl-new-list-block', [
            $el.P('screen-title', [$i18n.pr.booking_list_title, $el.DIV('s-flex'), $el.DIV('r-buttons', [download_pdf])]),
            $el.P('screen-mobile-title', $i18n.pr.booking_list_mobile_title),
            filter_bar,
            new UIList(grid, { classes: 'r-grid' })
        ])));

        this._doSearch();
    }

    private _doSearch() {
        if(!this._all_bookings) return;

        let bookings = this._all_bookings.filter(b => !b.is_test);

        if(this._filter_bar.sort_input?.value == 'number') {
            bookings.sort((a, b) => a.number.localeCompare(b.number));
        } else {
            bookings.sort((a, b) => (a.user_first_name + ' ' + a.user_last_name).localeCompare(b.user_first_name + ' ' + b.user_last_name));
        }

        bookings = this._filter_bar.search_input!.filterArray(bookings, (b, w) => {
            if((b.user_first_name + ' ' + b.user_last_name).toLowerCase().includes(w)) return true;
            if(b.number.toLowerCase().includes(w)) return true;
            return false;
        });

        this._grid.data = bookings;
    }
}
